var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSymbols = function SvgSymbols(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "m11.646 6.802.354.354.354-.354 1.091-1.092a4.132 4.132 0 1 1 5.845 5.845L12 18.845l-7.29-7.29a4.133 4.133 0 0 1 5.845-5.845z"
  })));
};
export { SvgSymbols as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIHN0cm9rZT0iIzdBNzM1OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJtMTEuNjQ2IDYuODAyLjM1NC4zNTQuMzU0LS4zNTQgMS4wOTEtMS4wOTJhNC4xMzIgNC4xMzIgMCAxIDEgNS44NDUgNS44NDVMMTIgMTguODQ1bC03LjI5LTcuMjlhNC4xMzMgNC4xMzMgMCAwIDEgNS44NDUtNS44NDVsMS4wOTEgMS4wOTJaIi8+PC9zdmc+";